export const GET_OCCUPIERS_FULL_LIST = 'GET_OCCUPIERS_FULL_LIST'
